import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M5 5.833c0-.46.373-.833.833-.833h8.75c.46 0 .834.373.834.833v8.75c0 .46-.373.834-.834.834h-8.75A.833.833 0 0 1 5 14.583v-8.75Z" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);